import { getData } from "../api.helpers";
import apiUrl from "./dropdown.Url";

export const getDropDownData = (key: string, type?:string, search?:string) =>
  getData(`${apiUrl.DROP_DOWN_URL}/${key}?${type}&search=${search}`).then((res) => res);
export const getCompanyDropDownData = (key: string) =>
  getData(`${apiUrl.DROP_DOWN_URL}/${key}`).then((res) => res);
